import { Device, DeviceSetting } from '../../common/types';
import { atomWithReset, atomWithStorage, createJSONStorage } from 'jotai/utils';
export const deviceListAtom = atomWithReset<Device[]>([]);

const storage = createJSONStorage<DeviceSetting[]>(() => localStorage);
export const deviceSettingAtom = atomWithStorage<DeviceSetting[]>('deviceSetting', [], storage, { unstable_getOnInit: true })